import "./style.scss";
import React from "react";
import PropTypes from "prop-types";
//import { useEffect } from "react";

const Counter = ({ cantCupDisponiblesLH = null, disable = false ,cantNumber=null}) => {
    //const [countCup,setCountCup]=useState([0,0,0,0]);
    //const numbers = [0,1, 2, 3];
    //cantCupDisponiblesLH  es un array [0,0,0,0]
    //  useEffect(() => {
    //      console.log(cantNumber);
    //  }); 
    

    return (
        <>
            {disable && cantCupDisponiblesLH != null && (
                <>
               
                {cantNumber == 1 ?
                    
                    <p className="counter-label-top label ">Solo Queda</p>:
                    <p className="counter-label-top label">Solo Quedan</p>
                }  
                <div className="counter ">
                        {cantCupDisponiblesLH.map((row, keyRow) => {
                            return (
                                <p key={keyRow} className="count-wrapper ">
                                    {row}
                                </p>
                            );
                        })}
                        </div>
                        {cantNumber == 1 ?
                         <p className="counter-label-bottom label">Cupon</p> 
                         :
                         
                           <p className="counter-label-bottom label">Cupones</p>  
                        }
                       
                </>
            )}
            </>
    );
};
Counter.propTypes = {
    cantCupDisponiblesLH: PropTypes.array,
    disable: PropTypes.bool,
    cantNumber:PropTypes.number,
};
export default Counter;
